import React, { useState } from 'react';
import './PromptTemplatesPage.css';
import PromptTemplateListGrid from '../../../components/settings/prompt-template/PromptTemplateListGrid';
import SystemPromptListGrid from '../../../components/settings/prompt-template/SystemPromptListGrid';
import PromptTemplateAddModal from '../../../components/settings/prompt-template/PromptTemplateAddModal';

const TABS = [
  { key: 'system', label: 'System Prompts' },
  { key: 'custom', label: 'Custom Templates' },
];

function PromptTemplatesPage() {
  const [activeTab, setActiveTab] = useState('system');
  const [refreshKey, setRefreshKey] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleOpenModal = () => {
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    setShowCreateModal(false);
  };

  const onTemplateCreated = () => {
    setRefreshKey(prev => prev + 1);
  };

  const isCustomTab = activeTab === 'custom';

  return (
    <div className="user-home-layout__page prompt-templates-page">
      <div className="user-home-layout__page-header">
        <div className="user-home-layout__page-header-main">
          <h1 className="user-home-layout__page-title">Prompt Templates</h1>
          <p className="user-home-layout__page-subtitle">
            {isCustomTab
              ? 'Discover reusable prompts to accelerate your workflows.'
              : 'Manage system-level master prompts that drive graph building, compilation, and query processing.'}
          </p>
        </div>
        <div className="user-home-layout__page-actions">
          {isCustomTab && (
            <button
              type="button"
              className="user-home-layout__action-button user-home-layout__action-button--primary"
              onClick={handleOpenModal}
            >
              + Add Template
            </button>
          )}
        </div>
      </div>

      <div className="prompt-templates-page__tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`prompt-templates-page__tab ${activeTab === tab.key ? 'prompt-templates-page__tab--active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {isCustomTab ? (
        <PromptTemplateListGrid key={`custom-${refreshKey}`} />
      ) : (
        <SystemPromptListGrid key={`system-${refreshKey}`} />
      )}

      <PromptTemplateAddModal
        showCreateModal={showCreateModal}
        handleCloseModal={handleCloseModal}
        onTemplateCreated={onTemplateCreated}
      />
    </div>
  );
}

export default PromptTemplatesPage;
